import $ from 'jquery';

import WOW from 'wowjs';
import Swiper from 'swiper/swiper-bundle.js';
import ScrollMagic from 'scrollmagic'
require('../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');

// Initializing wow.js
window.wow = new WOW.WOW({
	live: true,
	mobile: true
});

window.wow.init();

$(document).ready(function(){
	window.wow.sync();
});

// init controller
var controller = new ScrollMagic.Controller();

function rotate($obj, degree, move) {
	$obj.animate(
		{ right: "+"+move, rotation: degree, },
		{
			duration: 800,
			step: function (now, fx) {
				$obj.css({"-webkit-transform": "rotate(" + now + "deg)"});
				$obj.css({"-moz-transform": "rotate(" + now + "deg)"});
				$obj.css({"-ms-transform": "rotate(" + now + "deg)"});
				$obj.css({"-o-transform": "rotate(" + now + "deg)"});
			},
		}, 'linear');
}

$(document).ready(function(){
	rotate($('#s-1'), 350, 200);
	rotate($('#s-2'), 386, 100);
	rotate($('#s-3'), 390, 46);
	rotate($('#s-4'), 360, 75);
	$('.milk').toggleClass('animate');

    if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ) {

		// Play video after 300ms on non mobile devices...
		setTimeout( function() {
			$('#video-second video').get(0).play();
		}, 300);

    }
});

var isMobileVersion = false;
var swiper = null;

if ($(window).width() <= 767) {
	isMobileVersion = true;
	createSlidersForProducts();
}

$(window).on('resize', function(){
	const win = $(this); //this = window
	if (win.width() <= 767 && !isMobileVersion) {

		isMobileVersion = true;
		createSlidersForProducts();

	}
	else if (win.width() > 767 && isMobileVersion) {
		isMobileVersion = false;
		removeSlidersForProducts();
	}
});

function removeSlidersForProducts() {

	$('.product').each(function(i, obj) {

		$(obj).appendTo("#products");

		if(i === 1) {
			$("<hr class=\"dotted-hr\" style=\"margin: 0 0 30px 0;\">").appendTo("#products");
			$(".first-phrase").appendTo("#products");
			console.log(i);
		}
		else if(i === 3) {
			$("<hr class=\"dotted-hr\" style=\"margin: 0 0 60px 0;\">").appendTo("#products");
		}

	});

	$("#social-sites").appendTo("#products");

	$(".mySwiper").remove();
	$(".swiper-button-next").remove();
	$(".swiper-button-prev").remove();
	swiper.destroy();

}

function createSlidersForProducts() {

	$("#products hr").remove();

	$("#products").prepend(
		"<div class=\"swiper mySwiper\">" +
		"<div class=\"swiper-wrapper\"></div>" +
		"<div class=\"swiper-pagination\"></div>" +
		"</div>" +
		"<div class=\"swiper-button-next\"></div>" +
		"<div class=\"swiper-button-prev\"></div>"
	);

	$('.product').each(function(i, obj) {

		$('.swiper-wrapper').append('<div class="swiper-slide"></div>');
		$(obj).prependTo("#products .swiper-wrapper .swiper-slide:last-child");

	});

	swiper = new Swiper(".mySwiper", {
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
		},
	});


	$('.add1sDelay').each(function(){
		$(this).attr("data-wow-delay", "1.5s");
	});

	$('.add2sDelay').each(function(){
		$(this).attr("data-wow-delay", "2s");
	});
}





